import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CircularProgress from '@material-ui/core/CircularProgress';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import Box from '@material-ui/core/Box';
import { COLORS } from '../styles/colors';

export default class LoadMoreIcon extends Component {

	render() {
      return(
        <div style={{'textAlign': 'center', 'paddingTop': '10px'}}>
                <FontAwesomeIcon className="fa-spin" size="2x" icon={faCircleNotch} title={'Loading More'}
					style={{ color: COLORS.orange }} />
        </div>
      )
	}
}



// WEBPACK FOOTER //
// ./src/components/LoadMoreIcon.js